import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AssignmentLateIcon(props: IconProps) {
    return <Icon {...props} iconKey={"assignment_late"}/>
}
